import React, { Component } from 'react';
import * as $ from 'jquery';
import Events from './Events.js';
import EventSearch from './EventSearch.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';

export const EVENT_DATE = {
  ANY: 1,
  TODAY: 2,
  TOMORROW: 3,
  WEEKEND: 4,
  WEEK: 5,
  NWEEK: 6,
  MONTH: 7,
  NMONTH: 8
};

const dateFormat = "YYYY-MM-DD";

let cancelToken;
let state;
let tokenSession;

class EventsContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    if (this.state.events.length === 0) {
      this.reload();
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  didGetCenters = (response) => {
    this.setState({ centers: response });

    this.handleOptionUpdate();
  }

  didGetEvents = (response) => {
    const { t } = this.props;

    const callback = () => {
      if (this.state.events.length > 0) {
        $('html, body').animate({
          scrollTop: $('#events').offset().top - $('.navbar').height() - 20
        }, 800);
      } else {
        this.setState({ error: t('dashboard.events.no_results') });
      }
    };

    this.setState({
      events: response,
      isSearching: false
    }, callback);
  }

  getCenters = (params) => {
    this.props.post(
      "/getCenters",
      params,
      (response) => this.didGetCenters(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleOptionUpdate = () => {
    if ($("#center-results").children().length) {
      $("#center-results").css("display", "");
    } else {
      $("#center-results").css("display", "none");
    }
  }

  getEndDate = () => {
    switch (this.state.date) {
      default:
      case EVENT_DATE.ANY:
        return "";
      case EVENT_DATE.TODAY:
        return moment().format(dateFormat);
      case EVENT_DATE.TOMORROW:
        return moment().add(1, 'days').format(dateFormat);
      case EVENT_DATE.WEEKEND:
      case EVENT_DATE.WEEK:
        return moment().day(7).format(dateFormat);
      case EVENT_DATE.NWEEK:
        return moment().add(1, 'weeks').day(7).format(dateFormat);
      case EVENT_DATE.MONTH:
        return moment().endOf('month').format(dateFormat);
      case EVENT_DATE.NMONTH:
        return moment().add(1, 'months').endOf('month').format(dateFormat);
    }
  }

  getEvents = (params) => {
    this.props.post(
      "/getEvents",
      params,
      (response) => this.didGetEvents(response),
      (error) => {
        this.setState({ isSearching: false });
        this.props.handleErrorResponse(error);
      },
      cancelToken,
      () => this.setState({ isSearching: false })
    );
  }

  getInitState = () => {
    return {
      center: null,
      centerQuery: "",
      centers: [],
      date: EVENT_DATE.ANY,
      error: "",
      eventQuery: "",
      events: [],
      isSearching: false
    };
  }

  getStartDate = () => {
    switch (this.state.date) {
      default:
      case EVENT_DATE.ANY:
      case EVENT_DATE.TODAY:
      case EVENT_DATE.WEEK:
      case EVENT_DATE.MONTH:
        return moment().format(dateFormat);
      case EVENT_DATE.TOMORROW:
        return moment().add(1, 'days').format(dateFormat);
      case EVENT_DATE.WEEKEND:
        return moment().day(5).format(dateFormat);
      case EVENT_DATE.NWEEK:
        return moment().add(1, 'weeks').day(1).format(dateFormat);
      case EVENT_DATE.NMONTH:
        return moment().add(1, 'months').startOf('month').format(dateFormat);
    }
  }

  handleCenterClick = (center) => {
    this.setState({
      center: center,
      centerQuery: center.name,
    });
  }

  handleCenterSearch = (event) => {
    const getCenters = () => this.getCenters({
      query: this.state.centerQuery.length > 3  ? this.state.centerQuery : 'IOS',
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.setState({
      center: null,
      centerQuery: event.target.value
    }, getCenters);
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleDateChange = (event) => {
    this.setState({ date: Number(event.target.value) });
  }

  handleEventQuery = (event) => {
    this.setState({ eventQuery: event.target.value });
  }

  handleEventSearch = (event) => {
    event.preventDefault();

    this.setState({
      error: "",
      isSearching: true
    });

    this.reload();
  }

  reload = () => {
    this.getEvents({
      center_id: this.state.center ? this.state.center.id : "",
      end_date: this.getEndDate(),
      query: this.state.eventQuery.trim(),
      start_date: this.getStartDate(),
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  renderEvents = () => {
    return (
      <Events events={this.state.events} />
    );
  }

  renderEventSearch = () => {
    return (
      <EventSearch
        center={this.state.center}
        centers={this.state.centers}
        centerQuery={this.state.centerQuery}
        date={this.state.date}
        error={this.state.error}
        eventQuery={this.state.eventQuery}
        handleCenterClick={this.handleCenterClick}
        handleCenterSearch={this.handleCenterSearch}
        handleClearError={this.handleClearError}
        handleDateChange={this.handleDateChange}
        handleEventQuery={this.handleEventQuery}
        handleEventSearch={this.handleEventSearch}
        isSearching={this.state.isSearching} />
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="content-events ">
        <div className="container-events-title">
          <h2 className="page-header">{t('dashboard.events.heading')}</h2>
        </div>
        <div>
          <div className="content-events-search">
            {this.renderEventSearch()}
          </div>
          <div className="content-events-content">
            <div id="events">
              {this.renderEvents()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(EventsContainer);



// WEBPACK FOOTER //
// ./src/dashboard/events/EventsContainer.js